module.exports = __webpack_public_path__ + "img/RegionMicroSynteny_2.3aabaf34.jpg";